import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { PaymentMethodsPage } from '@/billing/pages/payment-methods';

export const Route = createFileRoute('/billing/payment-methods/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: PaymentMethodsRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function PaymentMethodsRoute() {
  return <PaymentMethodsPage/>;
}
